import { tenantConfig } from 'utils/tenant';
import { useError } from 'hooks/useError';
import { Outlet } from 'react-router';
import { EErrorCode } from 'config/errors-codes';

/**
 * SecureOutlet is a wrapper around the react-router Outlet component.
 * It performs additional checks to verify if the current tenant is allowed to access 3D Exhibition.
 */
export const SecureOutlet = () => {
  const throwError = useError();

  tenantConfig()
    .configLoaded.then(() => {
      if (tenantConfig().inactive === true) {
        throwError(EErrorCode.DISABLED_MARKET);
      }
    })
    .catch(() => {
      throwError(EErrorCode.DISABLED_MARKET);
    });

  return <Outlet />;
};
